module.exports = function() {
  return new Worker(__webpack_public_path__ + "d470c2a061f4e332966c.worker.js");
};